import { render, staticRenderFns } from "./QuizDetailPage.vue?vue&type=template&id=1acff967&scoped=true"
import script from "./QuizDetailPage.vue?vue&type=script&lang=js"
export * from "./QuizDetailPage.vue?vue&type=script&lang=js"
import style0 from "./QuizDetailPage.vue?vue&type=style&index=0&id=1acff967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acff967",
  null
  
)

export default component.exports